"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

var _default = (0, _styledComponents.css)(["flex:0 0 ", ";vertical-align:middle;margin-top:", ";width:20px;height:20px;", ""], function (props) {
  return props.theme.spacing.large;
}, function (props) {
  return props.theme.spacing.xxsmall;
}, function (_ref) {
  var media = _ref.theme.media;
  return media.smallMedium((0, _styledComponents.css)(["display:none;"]));
});

exports.default = _default;
//# sourceMappingURL=IconStyle.js.map